import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getModules = createAsyncThunk("admin/allModules", async ({ page, limit, searchData, courseId }, { rejectWithValue }) => {
  try {
    let url = `/module/all?`;
    if (page || limit) url += `page=${page}&limit=${limit}`;
    if (searchData) {
      url += `&search=${searchData}`;
    }
    if (courseId) {
      url += `&courseFilter=${courseId}`;
    }
    const response = await apiInstance.get(url, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const addModule = createAsyncThunk("admin/addModule", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/module/add`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const editModule = createAsyncThunk("admin/editModule", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/module/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const getSingleModule = createAsyncThunk("admin/singleModule", async (moduleId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/module/${moduleId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const deleteModule = createAsyncThunk("admin/deleteModule", async (selectedId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/module/delete/${selectedId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

const initialState = {
  moduleData: [],
  singleModuleData: [],
};

const moduleSlice = createSlice({
  name: "moduleSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getModules.fulfilled, (state, action) => {
      state.moduleData = action.payload.data;
    });
    builder.addCase(getSingleModule.fulfilled, (state, action) => {
      state.singleModuleData = action.payload.data;
    });
  },
});

export default moduleSlice.reducer;
